<template>
    <div
        class="preview-button"
    >
        <button
            class="button"
            :style="{'font-size': fontSize, 'margin': margin}"
            @click="createNewPreview()"
        >
            <img
                class="step-icon"
                :src="`/static/icon/${stepData.iconUrl}`"
            >
        </button>
        <p
            class="step-title"
            :style="{'font-size': fontSize, 'margin': margin}"
        >
            {{stepData.stepTitle}}
        </p>
        <button
            class="restart-button"
            :style="{'font-size': fontSize, 'margin': margin}"
            v-if="stepData.linkText"
            @click="createNewPreview()"
        >
            {{stepData.linkText}}
        </button>
    </div>
</template>

<script>
    import PreviewStepMixin from '@/components/Mixins/preview-step-mixin.vue';
    export default {

        name: 'Over',

        mixins: [PreviewStepMixin],

        data () {
            return {

            };
        }
    };
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Preview/PreviewStep/Over/index.vue